import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
    token: localStorage.getItem("token") || "",
    user: {},
    status: "",
};

const getters = {
    isLoggedIn: (state) => !!state.token,
    authState: (state) => state.status,
    user: (state) => state.user,
};

const actions = {
    async login({commit}, user) {
        commit("auth_request");
        let res = await axios.post(`${url}/users/login`, user);
        if (res.data.success) {
            const {token, user} = res.data;
            // Store the token into the localStorage
            localStorage.setItem("token", token);
            localStorage.setItem("userID", user._id);
            localStorage.setItem("userEmail", user.Email);
            localStorage.setItem("userName", user.Username);
            localStorage.setItem("Name", user.Name);
            localStorage.setItem("userRole", user.Role);
            localStorage.setItem("userState", user.State);
            localStorage.setItem("userPrograms", JSON.stringify(user.Program));
            localStorage.setItem("userCompanies", JSON.stringify(user.Company));
            if (
                user.Role === "Direct Care Staff" ||
                user.Role === "Shift Lead" ||
                user.Role === "Assistant Manager" ||
                user.Role === "House Manager" ||
                user.Role === "Program Manager" ||
                user.Role === "Human Resources" ||
                user.Role === "Finance Manager" ||
                user.Role === "Program Coordinator" ||
                user.Role === "Medical Manager" ||
                user.Role === "Compliance Manager" ||
                user.Role === "Executive Director" ||
                user.Role === "Administration" ||
                user.Role === "SuperAdministrator"
            ) {
                // localStorage.setItem('clientUserId', user._id);
                localStorage.setItem("staffId", user._id);
            } else if (user.Role === "Client") {
                localStorage.setItem("clientId", user.ClientID);
            }
            // else if(user.Role == "Direct Care Staff" ||
            //     user.Role == "Staff - Basic" ||
            //     user.Role == "Community - Setup" ||
            //     user.Role == "Staff - HR"||
            //     user.Role == "Administration"
            // ){
            //     localStorage.setItem('staffId', user._id);
            // }
            // Set the axios default
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token);
            commit("auth_user", user);
        }
        return res;
    },
    async logout({commit}) {
        commit("auth_request");
        localStorage.removeItem("token");
        localStorage.removeItem("userID");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userName");
        localStorage.removeItem("Name");
        localStorage.removeItem("userRole");
        //localStorage.removeItem('clientUserId');
        localStorage.removeItem("userPrograms");
        localStorage.removeItem("userState");
        localStorage.removeItem("clientUnit");
        localStorage.removeItem("staffId");
        localStorage.removeItem("clientId");
        localStorage.removeItem("openUnpublishNotif");
        localStorage.removeItem("userCompanies");

        // commit("logout");
        delete axios.defaults.headers.common["Authorization"];
    },

    async resetPassword({commit}, email) {
        commit("auth_request");

        try {
            return await axios.post(`${url}/users/forgot-password`, email);
        } catch (error) {
            return error;
        }
    },
    async updatePassword({commit}, data) {
        commit("auth_request");

        try {
            return await axios.post(`${url}/users/reset-password/${data.token}`, {
                Password: data.password,
            });
        } catch (error) {
            return error;
        }
    },
};

const mutations = {
    auth_request(state) {
        state.status = "loading";
    },
    auth_success(state, token, user) {
        state.token = token;
        state.user = user;
        state.status = "success";
    },
    auth_user(state, user) {
        state.user = user;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
